module.exports = __webpack_public_path__ + "img/20190704162036YY截图20190704013140.bd71209d.png";